import * as yup from "yup";
import { LocalizationService } from "@progress/kendo-react-intl";
import { enMessages } from "../../../messages/en-US";

interface ValidationParams {
  consumableNames: string[];
  localizationService: LocalizationService;
}

export default function consumableValidationSchema({ consumableNames, localizationService }: ValidationParams) {
  return yup.object().shape({
    name: yup
      .string()
      .required(localizationService.toLanguageString('custom.fieldIsRequired', enMessages.custom.fieldIsRequired))
      .max(32, localizationService.toLanguageString('custom.maxLengthExceeded', enMessages.custom.maxLengthExceeded))
      .test(
        'unique-name',
        localizationService.toLanguageString('custom.consumableNameExists', enMessages.custom.uniqueName),
        function(value) {
          if (!value) return true;
          return !consumableNames.some(
            existingName => existingName.toLowerCase() === value.toLowerCase()
          );
        }
      ),
    description: yup
      .string()
      .nullable(),
    type: yup.string(),
    photoUrl: yup.string(),
    partNumber: yup.string(),
    manufacturer: yup.string(),
    cost: yup.string()
  });
}
